import { render, staticRenderFns } from "./JThirdAppButton.vue?vue&type=template&id=49e9ab86&scoped=true&"
import script from "./JThirdAppButton.vue?vue&type=script&lang=js&"
export * from "./JThirdAppButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9ab86",
  null
  
)

export default component.exports